import {Input} from '@angular/core';
import {
    Component,
    OnInit
} from '@angular/core';
import {
    CMSMetaData,
    CMSConditions
} from '../../models/cms-data';
import {CMSService} from './service/cms.service';

@Component({
    selector: 'app-cms',
    templateUrl: './cms.component.html',
    styleUrls: ['./cms.component.scss']
})
export class CMSComponent implements OnInit {

    @Input() cmsData: CMSConditions;

    @Input() type: string;
    @Input() field: string;
    @Input() popoverText: string;
    @Input() header: string;

    cmsLinkData: CMSMetaData;

    constructor(private cmsService: CMSService) {
    }

    ngOnInit() {
        if (!this.cmsData) {
          this.cmsData = {
            field: this.field,
            size: '17',
            type: this.type,
            channelId: null
          };
        }
        this.cmsService.setCMSMetaData(this.cmsData);
        this.cmsLinkData = this.cmsService.getCMSMetaData();
    }

}
